export default __webpack_public_path__ + "static/media/zksync-test.725998c2.svg";